import { Box, CircularProgress, Typography } from '@mui/material';

export const LoadingComponent: React.FC<{ context?: string }> = ({ context }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        my: 10,
      }}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
        width="100%"
      >
        <CircularProgress />
      </Box>

      {context && (
        <Typography variant="body2" color="text.secondary">
          {context}
        </Typography>
      )}
    </Box>
  );
};
